import React, { useEffect, useState } from 'react';
import { View, Modal } from 'react-native';
import { useNavigation } from "@react-navigation/native";

import HeaderDefault from '../../components/HeaderDefault';
import AuthCodeInput from '../../components/Form/AuthCodeInput';
import ModalPurchase from '../../components/ModalPurchase';

import AsyncStorage from '@react-native-async-storage/async-storage';

import api from '../../services/api';

import styles from './styles';

const ConfirmPassword = (props) => {
    const navigation = useNavigation();
    const [password, setPassword] = useState('');
    const [modalVisible, setModalVisible] = useState(false);

    useEffect(() => {
        resetPassword();
    }, [password])

    const getBuyToken = async () => {
        const token = await AsyncStorage.getItem('JWT_TOKEN');
        const idCoin = await AsyncStorage.getItem('id_coin');

        var data = {
            qtd: props.route.params.qtd.qtd,
            id_coin: idCoin,
            valueToken: props.route.params.qtd.valueToken,
        }

        api.post('marketplace-moviments', data, { headers: { 'Authorization': `Basic ${token}` } })
            .then((res) => {
                console.log(res.data)
                setModalVisible(!modalVisible);
            })
            .catch((error) => {
                console.log(error);
            })
    }

    const getExchangeToken = async () => {
        const token = await AsyncStorage.getItem('JWT_TOKEN');
        const idCoin = await AsyncStorage.getItem('id_coin');

        var data = {
            quantity: props.route.params.qtd,
            id_token: idCoin,
            value: props.route.params.market == false ? props.route.params.valueCoin : null,
            is_purchase: props.route.params.purchase,
        }

        api.post('exchange-order', data, { headers: { 'Authorization': `Basic ${token}` } })
            .then((res) => {
                console.log(res.data)
                setModalVisible(!modalVisible);
            })
            .catch((error) => {
                console.log(error);
            })
    }


    function resetPassword() {
        if (password.length === 6 && props.route.params.market == null) {

            getBuyToken();

        } else if (password.length === 6) {
            getExchangeToken();
        }
    }

    return (
        <>
            <HeaderDefault title={props.route.params.titlePage} />

            <View style={styles.container}>
                <AuthCodeInput
                    cellCount={6}
                    isPassword={true}
                    value={password}
                    onValueChange={(value) => setPassword(value)}
                    label="Digite a sua senha abaixo"
                />
            </View>

            <Modal
                animationType="fade"
                transparent={false}
                visible={modalVisible}
                statusBarTranslucent={true}
                onRequestClose={() => navigation.navigate('Tabs')}
            >
                <ModalPurchase
                    handleCloseModal={() => {
                        setModalVisible(false);
                        navigation.navigate('Tabs');
                    }} />
            </Modal>
        </>
    );
}

export default ConfirmPassword;